// extracted by mini-css-extract-plugin
module.exports = {"container":"_1em80mALdgLkZoG_ZIOIxQ","cancelBtn":"_2Qam_8hF8DbvDgqZ6KxNyE","icon":"_19qndBQ_al7IJGLazKFIwX","saveBtn":"_3einRzLcj2ITGWj0SRRz12"};